import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GetProductQueryResponse, CreateProductCommand, UpdateProductCommand } from '../../interfaces/interfaces';
import { ProductsService } from '../products.service';
import { SuppliersService } from 'src/app/suppliers/suppliers.service';
import { AuthService } from 'src/app/services/auth.service';
import { StreamingService } from 'src/app/services/streaming.service';
import { take } from 'rxjs/operators';
import { map, Observable } from 'rxjs';
import { AdaptiveMode } from '@progress/kendo-angular-dateinputs';
import { DatePipe } from '@angular/common';
import { State, process, CompositeFilterDescriptor, filterBy } from "@progress/kendo-data-query";
import { ActivatedRoute, Router } from '@angular/router';
import { AddEvent, DataStateChangeEvent, GridComponent, GridDataResult } from '@progress/kendo-angular-grid';
import { environment } from 'src/environments/environment';
import { TelerikReportViewerComponent } from '@progress/telerik-angular-report-viewer';

@Component({
  selector: 'sdc-maintain-stock',
  templateUrl: './maintain-stock.component.html',
  styleUrls: ['./maintain-stock.component.scss']
})
export class MaintainStockComponent implements OnInit {
  @ViewChild('viewer1') viewer: TelerikReportViewerComponent;

  isLoading = true;
  isUpdate = false;
  productForm: UntypedFormGroup;
  processDate = false;
  userName: string;
  role: string;

  public isDiamondsChecked = true;
  public isStockReOrderedChecked = true;

  currentDate = new Date();
  createJewelleryCommand: CreateProductCommand;
  updateJewelleryCommand: UpdateProductCommand;

  public myFiles: Array<File>;


  public label1 = '';
  public label2 = '';
  public label3 = '';
  public label4 = '';
  public label5 = '';
  public label6 = '';

  public gridData: Observable<any>;
  public gridState: State = {
    sort: [],
    skip: 0,
    take: 5,
  };
  public filter: CompositeFilterDescriptor = {
    logic: "and",
    filters: [],
  };

  public allowCustom = true;
  public selectedValuesMetal: string = "Default";
  public listItemsMetal: Array<string> = [
    "Default",
  ];

  public selectedValues: string = "Cash";
  public listItemsPaymentMethod: Array<string> = [
    "Cash",
    "Debit/Credit Card",
    "Other",
  ];

  public valueStockDate: Date = new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate(), (new Date()).getHours());
  public valueStockReOrderDate: Date = new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate(), (new Date()).getHours());
  public format = "MM/dd/yyyy HH:mm";
  public adaptiveMode: AdaptiveMode = "auto";

  public selectedValuesSupplier: string = "Default";
  public listItemsSupplier: Array<string> = [
    "Default",
  ];

  public viewerContainerStyle =  {   
    position:  'relative',   
    width:  '800px',   
    height:  '600px', 
    left: '5px',
    right: '5px',   
    ['font-family']:  'ms sans serif'    
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public jewellery: GetProductQueryResponse,
    public dialogRef: MatDialogRef<MaintainStockComponent>,
    private productService: ProductsService,
    private streamingService: StreamingService,
    private authService: AuthService,
    private formBuilder: UntypedFormBuilder,
    private matSnackBar: MatSnackBar,
    private supplierService: SuppliersService,
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
  ) {
    if (this.jewellery.id > 0) {
      this.isUpdate = true;
    }
   }

   ngOnInit(): void {
    this.userName = JSON.parse(localStorage.getItem('currentUser')).userName;
    this.role = JSON.parse(localStorage.getItem('currentUser')).role;
    //alert(this.role);
    //this.role = localStorage.getitem('currentRole');
    console.log(this.jewellery);
    this.productForm = this.formBuilder.group({
      title: [null, Validators.required],
      store: [null],
      itemsPerUnit: [null],
      stockCount: [null, Validators.required],
    },);

    if (this.isUpdate) {
      this.productService.getProduct({id : this.jewellery.id}).pipe(take(1)).subscribe({
        next: (response: GetProductQueryResponse) => {
          this.productForm.patchValue(response);
        },
        error: (error: HttpErrorResponse) => {
          alert(error);
          this.isLoading = false;
        }
      });
      
    }
    else {
    }
    this.isLoading = false;
  }

  public parseObjectDates(target: any): any {
    const result = Object.assign({}, target);

    Object.keys(result).forEach((key) => {
      const date = new Date(result[key]);
      if (!isNaN(date.getTime())) {
        result[key] = date;
      }
    });

    return result;
  }

  updateProduct(): void {
    this.isLoading = true;
    this.updateJewelleryCommand = this.productForm.value;
    console.log(this.updateJewelleryCommand);

    var save = true;

    this.productService.getProduct({id : this.jewellery.id }).pipe(take(1)).subscribe({
      next: (response: GetProductQueryResponse) => {
        //alert(this.role);
        this.updateJewelleryCommand = response;
        console.log(this.updateJewelleryCommand);
        this.updateJewelleryCommand.stockCount = this.productForm.value.stockCount;

        //alert("Wait");
        //console.log(this.gridData);
        this.productService.updateProduct(this.updateJewelleryCommand).pipe(take(1)).subscribe({
          next: () => {
            this.isLoading = false;
            this.displayMessage('Stock Count updated');
            this.dialogRef.close();
          },
          error: (error: HttpErrorResponse) => {
            alert(error);
            this.isLoading = false;
          }
        });

        //alert("Test");
        this.isLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        //alert(error);
        this.isLoading = false;
      }
    });
  }

  updateRepairEvent(command: UpdateProductCommand): void {
    this.productService.updateProduct(command).pipe(take(1)).subscribe({
      next: () => {
        this.isLoading = false;
        this.displayMessage('Supplier updated');
        this.dialogRef.close();
      },
      error: (error: HttpErrorResponse) => {
        alert(error);
        this.isLoading = false;
      }
    });
    
  }

  private displayMessage(message: string): void {
    this.matSnackBar.open(message, 'Close', {
      duration: 7000
    });
  }
}
